import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const LoginGreeting: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const [showGreeting, setShowGreeting] = useState(false);

  // useEffect(() => {
  //   // 当用户认证状态变为已登录时显示问候语
  //   if (isAuthenticated && user) {
  //     setShowGreeting(true);

  //     // 5秒后自动隐藏问候语
  //     const timer = setTimeout(() => {
  //       setShowGreeting(false);
  //     }, 5000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [isAuthenticated, user]);

  if (!showGreeting || !isAuthenticated || !user) {
    return null;
  }

  return (
    <div className="login-greeting" style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      background: '#e6f7ff',
      padding: '15px',
      borderRadius: '5px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      zIndex: 1000,
      animation: 'fadeIn 0.5s'
    }}>
      <h3>欢迎回来, {user.name}!</h3>
      <p>您的角色是: <strong>{user.role}</strong></p>
    </div>
  );
};

export default LoginGreeting;